var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"tableinforcolor"},[_c('p',{staticClass:"tr mr-4"},[_vm._v(_vm._s(_vm.title))])]),_c('td',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }